import { useContext } from 'react';
import OwnerEntityContext from '../context/OwnerEntityContext';

const useOwnerEntity = () => useContext(OwnerEntityContext);

export default useOwnerEntity;
